
/*
 *
 *  utils
 *
 */


/**
 * @param {object} records 
 * @param {string} name 
 */
 export default function mapRecords(records, name) {
    console.log(records,name)
    switch (name) {  
        default:
            return records
    }
}
